@if (
  legalCondition?.acquisition &&
  (legalCondition.acquisition.acquisitionType?.definition ||
    legalCondition.acquisition.name ||
    legalCondition.acquisition.acquisitionDate ||
    legalCondition.acquisition.acquisitionLocation)
) {
  <section class="sheet-block">
    <h3 class="sheet-block-title">Acquisizione</h3>
    <dl class="sheet-facts">
      @if (legalCondition.acquisition.acquisitionType?.definition) {
        <div>
          <dt>Tipo di acquisizione</dt>
          <dd>{{ legalCondition.acquisition.acquisitionType.definition }}</dd>
        </div>
      }
      @if (legalCondition.acquisition.name) {
        <div>
          <dt>Nome</dt>
          <dd>{{ legalCondition.acquisition.name }}</dd>
        </div>
      }
      @if (legalCondition.acquisition.acquisitionDate) {
        <div>
          <dt>Data acquisizione</dt>
          <dd>{{ legalCondition.acquisition.acquisitionDate }}</dd>
        </div>
      }
      @if (legalCondition.acquisition.acquisitionLocation) {
        <div>
          <dt>Luogo acquisizione</dt>
          <dd>{{ legalCondition.acquisition.acquisitionLocation }}</dd>
        </div>
      }
    </dl>
  </section>
}

<section class="sheet-block">
  <h3 class="sheet-block-title">Condizione giuridica</h3>
  <dl class="sheet-facts">
    @if (legalCondition?.legal?.genericIndication?.definition) {
      <div>
        <dt>Indicazione generica</dt>
        <dd>{{ legalCondition.legal.genericIndication.definition }}</dd>
      </div>
    }
    @if (legalCondition?.legal?.specificIndication?.length > 0) {
      <div>
        <dt>Indicazioni specifiche</dt>
        <dd>
          @for (item of legalCondition.legal.specificIndication; track item; let i = $index) {
            {{ item.indication }}@if (i + 1 < legalCondition.legal.specificIndication.length) {; }
          }
        </dd>
      </div>
    }
  </dl>
</section>
